import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoClose } from "react-icons/io5";
import Modal from "react-bootstrap/Modal";
import FullPageLoader from "./loader/FullPageLoader";

const ManageWebinars = () => {
  const [showCreate, setShowCreate] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [webinarData, setWebinarData] = useState({
    webinar_title: "",
    createdAt: "",
    media: "",
    webinar_speaker_name: "",
    status: "",
    isblocked: false,
  });

  const [webinars, setWebinars] = useState([]);
  const [selectedWebinar, setSelectedWebinar] = useState(null);
  const [isloading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    fetchWebinars();
  }, []);

  const fetchWebinars = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/get-webinar`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setWebinars(data?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Webinars:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWebinarData({
      ...webinarData,
      [name]: value,
    });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const url = URL.createObjectURL(file);
      setWebinarData((prevData) => ({
        ...prevData,
        media: url,
      }));
    }
  };

  const handleCreate = async () => {
    const formData = new FormData();
    formData.append("webinar_title", webinarData.webinar_title);
    formData.append("createdAt", webinarData.createdAt);
    formData.append("webinar_speaker_name", webinarData.webinar_speaker_name);
    formData.append("status", webinarData.status);
    if (selectedFile) {
      formData.append("media", selectedFile);
    }
    formData.append("is_blocked", webinarData?.isblocked);

    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/get-webinar`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        //console.log("Webinar created successfully");
        setShowCreate(false);
        fetchWebinars();
      } else {
        console.error("Failed to create Webinar");
      }
    } catch (error) {
      console.error("Error creating Webinar:", error);
    }
  };

  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append("webinar_title", "");
    // formData.append("createdAt", date);
    formData.append("webinar_speaker_name", webinarData.webinar_speaker_name);
    formData.append("status", webinarData.status);
    if (selectedFile) {
      formData.append("media", selectedFile);
    }
    formData.append("is_blocked", webinarData?.isblocked);

    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/get-webinar/${selectedWebinar._id}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (response.ok) {
        //console.log("Webinar updated successfully");
        setShowDetails(false);
        setEditMode(false);
        fetchWebinars();
      } else {
        console.error("Failed to update Webinar");
      }
    } catch (error) {
      console.error("Error updating Webinar:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/get-webinar/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (response.ok) {
        //console.log("Webinar deleted successfully");
        fetchWebinars();
      } else {
        console.error("Failed to delete Webinar");
      }
    } catch (error) {
      console.error("Error deleting Webinar:", error);
    }
  };

  const handleShowDetails = async (id) => {
    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/get-webinar/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSelectedWebinar(data.data);
      setWebinarData(data.data || {});
      setShowDetails(true);
      setEditMode(false);
    } catch (error) {
      console.error("Error fetching webinar details:", error);
    }
  };

  const convert = (webinarDetail) => {
    const videoUrl = webinarDetail;
    const embedUrl = videoUrl
      ? videoUrl.includes("watch?v=")
        ? videoUrl.replace("watch?v=", "embed/").replace("&list=", "?list=")
        : videoUrl
      : null;
    return embedUrl;
  };

  return (
    <>
      {isloading ? (
        <FullPageLoader />
      ) : (
        <div className="container-fluid ps-3">
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowCreate(true);
                setWebinarData({
                  webinar_title: "",
                  createdAt: "",
                  media: "",
                  webinar_speaker_name: "",
                  status: "",
                });
                setSelectedFile(null);
              }}
            >
              Create New Webinar
            </button>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">No</th>
                    <th scope="col">webinar_title</th>
                    <th scope="col">Webinar Speaker Image</th>
                    <th scope="col">Webinar Thumbnail Image</th>
                    <th scope="col">Webinar Video</th>
                    <th scope="col">Webinar Speaker Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Created At</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {webinars.map((webinar, index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>{webinar?.webinar_title}</td>
                      <td>
                        <img
                          src={`https://api.greymatterz.com/${webinar?.webinar_speaker_image}`}
                          style={{ height: "50px", width: "auto" }}
                          alt="webinar"
                        />
                      </td>
                      <td>
                        <img
                          src={`https://api.greymatterz.com/${webinar?.webinar_thumbnail_image}`}
                          style={{ height: "50px", width: "auto" }}
                          alt="webinar"
                        />
                      </td>
                      <td>
                        <iframe
                          width="560"
                          height="215"
                          src={convert(webinar?.webinar_video)}
                          style={{ border: "none" }}
                          title="Webinar Video"
                        />
                      </td>
                      <td>{webinar?.webinar_speaker_name}</td>
                      <td>{webinar?.status}</td>
                      <td>{webinar?.createdAt}</td>
                      <td>
                        <button
                          className="btn btn-info btn-sm me-2"
                          onClick={() => handleShowDetails(webinar?.slug_url)}
                        >
                          Details
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(webinar._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Create New webinar Modal */}
      <Modal show={showCreate} onHide={() => setShowCreate(false)}>
        <Modal.Body>
          <h3 className="text-center py-4 position-relative title">
            Create New webinar
            <span
              className="modalClose"
              onClick={() => setShowCreate(false)}
              style={{ cursor: "pointer" }}
            >
              <IoClose />
            </span>
          </h3>

          <div className="p-4">
            <div className="form-group mb-4">
              {/* <label>
                <h6>Uploaded By</h6>
              </label>
              <input
                type="text"
                name="webinar_title"
                value={WebinarData.webinar_title}
                onChange={handleChange}
                className="form-control"
                disabled
              /> */}

              <label>
                <h6>Webinar</h6>
              </label>
              <input
                type="file"
                onChange={handleImageUpload}
                className="form-control"
              />
              {webinarData.media && (
                <img
                  src={webinarData.media}
                  alt="Preview"
                  style={{ marginTop: "10px", width: "100px", height: "auto" }}
                />
              )}

              <label>
                <h6>Webinar Type</h6>
              </label>
              <input
                type="text"
                name="webinar_speaker_name"
                value={webinarData.webinar_speaker_name}
                onChange={handleChange}
                className="form-control"
              />

              <label>
                <h6>Status</h6>
              </label>
              <input
                type="text"
                name="status"
                value={webinarData.status}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Webinar Details Modal */}
      <Modal show={showDetails} onHide={() => setShowDetails(false)}>
        <Modal.Body>
          <h3 className="text-center py-4 position-relative title">
            Webinar Details
            <span
              className="modalClose"
              onClick={() => setShowDetails(false)}
              style={{ cursor: "pointer" }}
            >
              <IoClose />
            </span>
          </h3>

          <div className="p-4">
            <div className="form-group mb-4">
              {/* <label>
                <h6>Uploaded By</h6>
              </label>
              <input
                type="text"
                name="webinar_title"
                value={webinarData.webinar_title}
                onChange={handleChange}
                className="form-control"
                disabled
              /> */}

              <label>
                <h6>Webinar</h6>
              </label>
              <input
                type="file"
                onChange={handleImageUpload}
                className="form-control"
                disabled={!editMode}
              />
              {webinarData.media && (
                <img
                  src={webinarData.media}
                  alt="Preview"
                  style={{ marginTop: "10px", width: "100px", height: "auto" }}
                />
              )}

              <label>
                <h6>Webinar Type</h6>
              </label>
              <input
                type="text"
                name="webinar_speaker_name"
                value={webinarData.webinar_speaker_name}
                onChange={handleChange}
                className="form-control"
                disabled={!editMode}
              />

              <label>
                <h6>Status</h6>
              </label>
              <input
                type="text"
                name="status"
                value={webinarData.status}
                onChange={handleChange}
                className="form-control"
                disabled={!editMode}
              />
            </div>
            {editMode && (
              <div className="d-flex justify-content-end">
                <button className="btn btn-primary me-2" onClick={handleUpdate}>
                  Update
                </button>
              </div>
            )}
            {!editMode && (
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-warning me-2"
                  onClick={() => setEditMode(true)}
                >
                  Edit
                </button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ManageWebinars;
